import { RECOVERY_OTP } from '../constants/mfa'

export const isMFAEnabled = (
  enabledMFAMechanisms = [],
  isLocalLoginEnabled = false,
) =>
  enabledMFAMechanisms.filter((mfa) => mfa !== RECOVERY_OTP).length > 0 &&
  isLocalLoginEnabled
